module.exports = __webpack_public_path__ + "static/media/alert-octagon.ec65a85b.svg";